import { createSelector } from 'reselect';

const getErrorState = (state) => {
  return state.GlobalErrorComponent;
};

export const getErrorVisibleState = createSelector(getErrorState, (errorState) => {
  return errorState?.visible;
});

export const getErrorModalVisibleState = createSelector(getErrorState, (errorState) => {
  return errorState?.errorModalVisible;
});

export const getErrorMessage = createSelector(getErrorState, (errorState) => {
  return errorState?.errorMsg;
});
